import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

/** The strict small-document reader both file formats share: open, validate the head, run the items loop. */
export class AppDocItems {
    /** The shared Parse: gate, the format's own empty rule, head validation, then the items loop. */
    public static Open<TDoc extends { Found: boolean; PersonKey: string; Items: TItem[] }, TItem extends { Id: string }>(
        Text: string, ObjectIn: (Text: string) => Record<string, unknown> | null, Schema: number,
        Make: () => TDoc, Bad: () => TDoc, ItemIn: (Raw: unknown) => TItem | null,
        Empty: TDoc | null, Label: string): TDoc {
        if (getCoreUtils().KErrorMode === true) { return Bad(); }
        try {
            if (Empty !== null && nz(Text).trim().length === 0) { return Empty; }
            const Doc: Record<string, unknown> | null = ObjectIn(Text);
            if (Doc === null || Number(Doc.schema) !== Schema || Array.isArray(Doc.items) === false) { return Bad(); }
            if (Doc.personKey !== undefined && typeof Doc.personKey !== "string") { return Bad(); }
            const Out: TDoc = Make();
            return AppDocItems.Into(Out, Doc, ItemIn, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, Label);
            return Bad();
        }
    }

    /** The strict items loop both readers run: per-item shape check plus id dedup. */
    public static Into<TDoc extends { Found: boolean; PersonKey: string; Items: TItem[] }, TItem extends { Id: string }>(
        Out: TDoc, Doc: Record<string, unknown>, ItemIn: (Raw: unknown) => TItem | null, Bad: () => TDoc): TDoc {
        Out.Found = true;
        const Key: string = nz(Doc.personKey as string);
        Out.PersonKey = Key;
        const Seen: Record<string, boolean> = {};
        const RawItems: unknown[] = Doc.items as unknown[];
        for (const Raw of RawItems) {
            const Item: TItem | null = ItemIn(Raw);
            const Duplicate: boolean = Item !== null && Seen[Item.Id] === true;
            if (Item === null || Duplicate === true) { return Bad(); }
            Seen[Item.Id] = true;
            Out.Items.push(Item);
        }
        return Out;
    }
}
